import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';

import HookFormWrapper from '../../../components/HookFormWrapper/HookFormWrapper';
import { VpStripePaymentMethod, VpStripePlanInfoAlert } from '../../widgets';
import { useFetchPlanData, useFetchSubscription, useUpdateSubscription } from '../../../hooks';
import { VpButton } from '../../components';
import { useCreateSubscription } from '../../../hooks';
import { useVpSnackbar } from '../../hooks';

const typographyStyles = {
  mb: '10px'
};
const upgradeButtonStyles = {
  mt: '20px'
};

export const UpdateSubscriptionDialogContent = ({
  plan = '',
  onUpdateClick = null,
  onClose = null,
  refreshAuthStateAction
}) => {
  if (!plan) {
    return null;
  }

  const { addSnackbarSuccess } = useVpSnackbar();
  const { data: fetchPlanData } = useFetchPlanData(plan);
  const { data: subscriptionData } = useFetchSubscription();
  const {
    mutate: createSubscription,
    isLoading: isCreateLoading,
    isSuccess: isCreateSuccess
  } = useCreateSubscription();
  const {
    mutate: updateSubscription,
    isLoading: isUpdateLoading,
    isSuccess: isUpdateSuccess
  } = useUpdateSubscription();

  const hasCard = !!subscriptionData?.card;
  const isLoading = isCreateLoading || isUpdateLoading;
  const planData = fetchPlanData?.data;

  const onSubmit = () => {
    const data = {
      planId: planData?.planId
    };
    const subscriptionId = subscriptionData?.id;

    subscriptionData?.hasSubscription
      ? updateSubscription({ data, subscriptionId })
      : createSubscription({ data });
  };

  useEffect(() => {
    if (isCreateSuccess || isUpdateSuccess) {
      addSnackbarSuccess({
        message: `Successfully upgraded to ${planData?.label}`
      });
      onClose && onClose();
      refreshAuthStateAction(true);
    }
  }, [isCreateSuccess, isUpdateSuccess]);

  const PaymentDetails = (
    <>
      <Typography sx={typographyStyles}>Plan Summary</Typography>
      <VpStripePlanInfoAlert plan={planData} disablePromoCode />
      <VpStripePaymentMethod onUpdateClick={onUpdateClick} onClose={onClose} />
    </>
  );

  return (
    <>
      {hasCard ? (
        <HookFormWrapper onSubmit={onSubmit}>
          {PaymentDetails}
          <VpButton
            sx={upgradeButtonStyles}
            fullWidth
            loading={isLoading}
            type="submit"
            size="large"
            variant="contained"
            data-testid="vpPlanUpgradeButton"
          >
            Upgrade
          </VpButton>
        </HookFormWrapper>
      ) : (
        PaymentDetails
      )}
    </>
  );
};

UpdateSubscriptionDialogContent.propTypes = {
  plan: PropTypes.string.isRequired,
  onUpdateClick: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  refreshAuthStateAction: PropTypes.func.isRequired
};

export default UpdateSubscriptionDialogContent;



// WEBPACK FOOTER //
// ./src/vp-ui/dialogs/VpUpdateSubscriptionDialog/UpdateSubscriptionDialogContent.jsx